<style>
.red {
  color: #4fa1a4;
}
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.function-wrap {
  position: relative;
  /* height: 50px; */
  line-height: 50px;
  /* padding: 10px 20px; */
  box-sizing: border-box;
  text-align: center;
  border-bottom: 1px solid #D9D9D9;
  background: #fff;
}

.back-btn {
  position: absolute;
  top: 12px;
  left: 10px;
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}
.flex{
  display: flex;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="function-wrap">
      <h1>{{ subTitle }}</h1>
      <div class="back-btn" @click="$router.go(-1)">返回</div>
    </div>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6" class="flex">
          <div class="search-area-div" >应用公司：</div>
          <el-select size="mini" @change="handleChangeCompany" v-model="page.tenantGuid" placeholder="请选择" class="ipt-sty"
            style="width: 260px" filterable>
            <el-option
              v-for="item in sendTenantList" 
              :key="item.guid"
              :label="item.name"
              :value="item.guid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="flex">
          <div class="search-area-div">应用部门：</div>
          <el-select size="mini" v-model="page.organisationGuid" filterable placeholder="请选择执行部门" class="ipt-sty"
            style="width: 260px">
            <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName"
              :value="item.guid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="flex">
          <div class="search-area-div">标准模版：</div>
          <el-select size="mini" v-model="page.isDefaultConfig" filterable placeholder="请选择执行部门" class="ipt-sty"
            style="width: 260px">
            <el-option v-for="item in [{label:'全部',value:null},{label:'是',value:'Y'},{label:'否',value:'N'},]" :key="item.value" :value="item.value"
              :label="item.label"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="flex">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">新增配置</el-button>
      </div>

      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="应用公司" show-overflow-tooltip header-align="center" align="left"
          fixed="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column prop="organisationName" label="应用部门" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="isDefaultConfig" label="标准模版" width="70px" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="(scope.row.isDefaultConfig == 'Y') ? 'red':''">{{ scope.row.isDefaultConfig == 'Y' ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inputTime" label="配置人" width="100px" header-align="center" align="left"
            show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.updateUserName || scope.row.createUserName || '-' }}</template>
          </el-table-column>
        <el-table-column prop="inputTime" label="配置时间" width="100px" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.inputTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="360px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.isDefaultConfig == 'N'">
              <a class="txt-color" @click="preview(scope.row, 0)">预览 ｜</a>
              <a class="txt-color" @click="editVersion(scope.row, 0)">复制 ｜</a>
              <a class="txt-color" @click="editVersion(scope.row, 1)">编辑 ｜</a>
              <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
              <a class="txt-color" v-if="scope.row.isDefaultConfig == 'N' && isOpen" @click="setDefault(scope.row.guid)">｜设为默认｜</a>
              <a class="txt-color" @click="setProcess(scope.row)">{{isOpen?'':'｜'}}{{'关联流程'}}</a>
              <a class="txt-color" @click="seeLog(scope.row)"> ｜变更日志</a>
            </template>
            <template v-if="scope.row.isDefaultConfig == 'Y'">
              <a class="txt-color" @click="preview(scope.row, 0)">预览 ｜</a>
              <a class="txt-color" @click="editVersion(scope.row, 0)">复制 ｜</a>
              <a class="txt-color" v-if="isDefaultConfigOpen" @click="editVersion(scope.row, 1)">编辑 ｜</a>
              <a class="txt-color" v-if="isDefaultConfigOpen" @click="delVersion(scope.row.guid)">删除 ｜</a>
              <a class="txt-color" v-if="scope.row.isDefaultConfig == 'N' && isOpen" @click="setDefault(scope.row.guid)">{{isDefaultConfigOpen ? '':''}}{{'设为默认｜'}}</a>
              <a class="txt-color" @click="setProcess(scope.row)">{{isOpen?'':''}}{{'关联流程'}}</a>
              <a class="txt-color" @click="seeLog(scope.row)"> ｜变更日志</a>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- start of dialog-关联流程 -->
    <el-dialog title="关联流程" :visible.sync="isOpenProcess" width="500px">
      <div class="col-itms">
        <div class="title"><span>*</span>应用公司：</div>
        <div>{{ processForm.tenantName }}</div>
      </div>
      <div class="col-itms">
        <div class="title"><span>*</span>是否需要审批：</div>
        <el-radio-group v-model="processForm.isNeed">
          <el-radio label="Y">是</el-radio>
          <el-radio label="N">否</el-radio>
        </el-radio-group>
      </div>
      <div class="col-itms" v-if="processForm.isNeed == 'Y'">
        <div class="title"><span style="color:#fff;">*</span>新增流程：</div>
        <el-select class="w250" clearable v-model="processForm.workflowTemplateList[0].flowTemplateGuid" placeholder="请选择"
          filterable>
          <el-option v-for="item in processList" :key="item.guid" :label="item.flowName" :value="item.guid">
          </el-option>
        </el-select>
        <span class="to-setting" @click="processSetting">去配置</span>
      </div>
      <div class="col-itms" v-if="processForm.isNeed == 'Y'">
        <div class="title"><span style="color:#fff;">*</span>编辑流程：</div>
        <el-select class="w250" clearable v-model="processForm.workflowTemplateList[1].flowTemplateGuid" placeholder="请选择"
          filterable>
          <el-option v-for="item in processList" :key="item.guid" :label="item.flowName" :value="item.guid">
          </el-option>
        </el-select>
        <span class="to-setting" @click="processSetting">去配置</span>
      </div>
      <div class="col-itms" v-if="processForm.isNeed == 'Y'">
        <div class="title"><span style="color:#fff;">*</span>删除流程：</div>
        <el-select class="w250" clearable v-model="processForm.workflowTemplateList[2].flowTemplateGuid" placeholder="请选择"
          filterable>
          <el-option v-for="item in processList" :key="item.guid" :label="item.flowName" :value="item.guid">
          </el-option>
        </el-select>
        <span class="to-setting" @click="processSetting">去配置</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="isOpenProcess = false">取 消</el-button>
        <el-button size="mini" type="info" @click="processSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-关联流程 -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      page: {
        isDefaultConfig:null,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        functionGuid: this.$route.query.functionGuid,
        tenantGuid: '',
        organisationGuid: '',
      },
      functionCode: '',
      functionName: '',
      functionDesc: '',
      guid: '',
      height: window.innerHeight - 340,
      right: 'right',
      tableData: [],
      dialogVisible: false,
      sendTenantList: [],
      organisationList: [],
      subTitle: "",

      isOpenProcess: false,
      processForm: {

      },
      processList: [],
      btnConfig:null // GNPZ默认按钮开关配置
    };
  },
  created() {
    this.subTitle = localStorage.threeLevels + '功能配置';
    if (sessionStorage.page2) {
      let page = JSON.parse(sessionStorage.page2);
      if (page.functionGuid && page.functionGuid === this.$route.query.functionGuid) this.page = page
      if(page.tenantGuid)this.handleChangeCompany(page.tenantGuid,1)
      sessionStorage.removeItem('page2')
    }
    this.getList();
    this.getSendTenantList();
    this.getGNConfig()
  },
  computed: {
    haveDefaultConfig() {
      return this.tableData.findIndex(item=>item.isDefaultConfig === 'Y') !== -1
    },
    isDefaultConfigOpen() {
      return this.btnConfig && this.btnConfig.parameterValue === '开'
    },
    isOpen() {
      let flag = false
      if (this.btnConfig && this.btnConfig.parameterValue === '开') {
        flag = true
      } else if (this.btnConfig && this.btnConfig.parameterValue === '关') {
        if (this.haveDefaultConfig) {
          flag = false // 有默认值 则隐藏设为默认\编辑\删除
        } else {
          flag = true
        }
      }
      return flag
    }
  },
  methods: {
    search() {
      let self = this;
      self.tableLoading = true;
      this.page.pageIndex =1;
      this.page.pageSize =50;
      this.page.totalPage =0;
      this.page.totalPage =0;
      self.api.postJson(`/${serverConfig.msConfigureService}/function/function-tenant/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        functionGuid: this.$route.query.functionGuid,
        tenantGuid: null,
        organisationGuid:null,
        isDefaultConfig:null
      };
      this.getList();
    },
    //新增
    addVersion() {
      let query = {
        functionGuid: this.$route.query.functionGuid,
        functionCode: this.$route.query.functionCode,
      };
      let path = '/h5ConfigFieldAdd';
      if (this.$route.query.productGuid) {
        query.productGuid = this.$route.query.productGuid;
      }
      this.$router.push({
        path,
        query,
      });
    },
    //编辑
    editVersion(detail, type) {
      sessionStorage.setItem('page2', JSON.stringify(this.page));
      let query = {
        functionGuid: this.$route.query.functionGuid,
        functionCode: this.$route.query.functionCode,
        guid: detail.guid,
        type,
      };
      let path = '/h5ConfigFieldAdd';
      if (this.$route.query.productGuid) {
        query.productGuid = this.$route.query.productGuid;
      }
      this.$router.push({
        path,
        query,
      });


    },
    //预览
    preview(detail) {
      let functionCode = this.$route.query.functionCode;
      let userName = '13900000001';
      const userPwd = '666666';
      let previewUrl;
      this.fullscreenLoading = true;
      this.api.get(`/${serverConfig.msConfigureService}/function-path/get/function-path?functionCode=${functionCode}`).then((res) => {
        this.fullscreenLoading = false;
        if (!res.data.data) {
          this.$message.error('请先去维护预览路径')
          return;
        }
        previewUrl = `https://llscmtest.cs4pl.com/loginRoot?tenantGuid=${detail.tenantGuid}&organisationGuid=${detail.organisationGuid}&userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(res.data.data.formUrl)}`;
        if (location.href.indexOf('https://scm-operation.csyaoly.com') > -1) { //生产1
          userName = '13900001026';
          previewUrl = `https://llscm.csyaoly.com/loginRoot?tenantGuid=${detail.tenantGuid}&organisationGuid=${detail.organisationGuid}&userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(res.data.data.formUrl)}`
        }
        if (location.href.indexOf('https://scm-operation.cs4pl.com') > -1) { //生产2
          userName = '13900001026';
          previewUrl = `https://llscm-pre.cs4pl.com/loginRoot?tenantGuid=${detail.tenantGuid}&organisationGuid=${detail.organisationGuid}&userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(res.data.data.formUrl)}`
        }
        window.open(location.origin + '/previewPage?previewUrl=' + encodeURIComponent(previewUrl))
      })
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/function/function-tenant/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //设置默认
    setDefault(guid) {
      // if (this.btnConfig.parameterValue === '关') {
      //   this.$message.warning('请联系管理员')
      //   return
      // }
      let self = this;
      let req = { guid }
      self.api.postJson(`/${serverConfig.msConfigureService}/function/function-tenant/set-to-default`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('设置成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    //设置流程
    setProcess(res) {
      this.isOpenProcess = true;
      this.processForm = {
        isModify: 'N',
        isNeed: 'N',
        tenantGuid: res.tenantGuid,
        tenantName: res.tenantName,
        workflowTemplateList: [{
          flowOperationType: 1,
          flowTemplateGuid: ''
        }, {
          flowOperationType: 2,
          flowTemplateGuid: ''
        }, {
          flowOperationType: 3,
          flowTemplateGuid: ''
        }]
      }
      this.getProcessList(res.tenantGuid);
    },
    //变更日志
    seeLog(res){
      sessionStorage.setItem('page2', JSON.stringify(this.page));
      this.$router.push({ 
        path: 'h5ConfigLog',
        query: { 
          productGuid: this.$route.query.productGuid,
          guid:res.guid,
          functionGuid:this.$route.query.functionGuid,
          functionCode:this.$route.query.functionCode
        } 
      })
    },
    processSetting() {
      this.$router.push({ path: 'processSettings', query: { productGuid: this.$route.query.productGuid } })
    },
    //获取流程
    getProcessList(tenantGuid) {
      let req = {
        tenantGuid,
        pageIndex: 1,
        pageSize: -1
      }
      this.api.postJson(`/${serverConfig.msConfigureService}/flow/data/flow-template-page-list`, req).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.processList = res.data.data.records;
          this.getProcessDetail();
        }
      });
    },
    //获取关联流程详情
    getProcessDetail() {
      let req = {
        functionGuid: this.$route.query.functionGuid,
        tenantGuid: this.processForm.tenantGuid,
      }
      this.api.get(`/${serverConfig.msConfigureService}/function-workflow/data/get`, req).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          this.processForm.isModify = !data.workflowTemplateList ? 'N' : 'Y';
          this.processForm.isNeed = !data.workflowTemplateList ? 'N' : 'Y';
          if (!data.workflowTemplateList) {
            this.processForm.workflowTemplateList = [{
              flowOperationType: 1,
              flowTemplateGuid: ''
            }, {
              flowOperationType: 2,
              flowTemplateGuid: ''
            }, {
              flowOperationType: 3,
              flowTemplateGuid: ''
            }]
          } else {
            let workflowTemplateList = this.processForm.workflowTemplateList;
            data.workflowTemplateList.forEach(i => {
              workflowTemplateList.forEach(j => {
                if (j.flowOperationType == i.flowOperationType) {
                  j.flowTemplateGuid = i.flowTemplateGuid;
                }
              })
            })
          }
        }
      });
    },
    //提交关联流程
    processSubmit() {
      let workflowTemplateList = [];
      this.processForm.workflowTemplateList.forEach(item => {
        if (item.flowTemplateGuid) {
          workflowTemplateList.push(item);
        }
      })
      let req = {
        functionGuid: this.$route.query.functionGuid,
        tenantGuid: this.processForm.tenantGuid,
      };
      if (this.processForm.isModify == 'N') {
        req.workflowTemplateList = workflowTemplateList;
        this.api.postJson(`/${serverConfig.msConfigureService}/function-workflow/data/add`, req).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('关联成功');
            this.isOpenProcess = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else if (this.processForm.isModify == 'Y' && workflowTemplateList.length && this.processForm.isNeed == 'Y') {
        req.workflowTemplateList = this.processForm.workflowTemplateList;
        this.api.put(`/${serverConfig.msConfigureService}/function-workflow/data/update`, req).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('关联成功');
            this.isOpenProcess = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        this.api.postJson(`/${serverConfig.msConfigureService}/function-workflow/data/delete?functionGuid=${this.$route.query.functionGuid}&tenantGuid=${this.processForm.tenantGuid}`).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('关联成功');
            this.isOpenProcess = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    delVersion(guid) {
      var self = this;
      var req = [guid];
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msConfigureService}/function/function-tenant/del`, req).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    // getSendTenantList(flag = true) {
    //   let that = this;
    //   let req = {
    //     pageIndex: 1,
    //     pageSize: -1,
    //     currentTenantGuid: localStorage.guid,
    //     tenantName: ''
    //   }
    //   that.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants`, req).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       let { data } = res;
    //       if (data.data && data.data.records) {
    //         that.sendTenantList = data.data.records || [];
    //       }
    //     } else {
    //       that.$message.error(res.data.msg);
    //     }
    //   });
    // },
    //获取药企
    getSendTenantList() {
      let self = this; 
      let query={
        pageIndex: 1,
        pageSize: -1,
        bizState:'Y',
        memberStatus:'ZSHY',
        enterpriseCates: [...this.$getValueListByKey('上游客户分类'), '9901']
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,query).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list= res.data.data.records|| [];   
          self.sendTenantList=[]
          console.log('list',list);
          if(list.length>0){
            list.forEach(item=>{
              let obj={}
              obj={
                guid:item.sendTenantGuid,
                name:item.sendTenantName,
              }
              self.sendTenantList.push(obj)
            })
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleChangeCompany(v,flg) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(!flg){
            self.page.organisationGuid = '';
          }
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getGNConfig() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=GNPZZDCZKG`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            this.btnConfig = data.find((item) => item.name == '默认开关');
            //console.log(res);
          }
        });
    },
  },
};
</script> 
<style scoped>
.content h1 {
  margin: 0;
  /* margin-bottom: 16px; */
  font-size: 18px;
}

.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 54px - 60px);
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid #D9D9D9;
  padding: 20px;
  padding-bottom: 15px;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

.col-itms {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}

.col-itms .title {
  padding-right: 10px;
  width: 120px;
  text-align: right;
}

.col-itms .title span {
  color: red;
}

.to-setting {
  margin-left: 10px;
  color: #4fa1a4;
  cursor: pointer;
}
.search-area-div {
  width: 90px;
  text-align: right;
}
.ipt-sty {
  flex: 1;
}
</style>